import { lazy, Suspense } from "react";

import { Loader } from "../../components/ui/Loader";

import { returnEnvironment } from "../../utils";

const WizardEditUserInfo = lazy(() => import("./wizard"));
const DefaultEditUserInfo = lazy(() => import("./default"));

export const EditUserInfo = () => {
    const environment = returnEnvironment();
    
    return (
        <Suspense fallback={<Loader />}>
            {environment === "wizard" ? <WizardEditUserInfo /> : <DefaultEditUserInfo />}
        </Suspense>
    );
};

export default EditUserInfo;
